const stripe = {
  // @ts-ignore
  API_KEY: window._env_.REACT_APP_STRIPE_API_KEY,
};

export default stripe;
